import {
  err,
  ok,
  parseReturnYoutubeDislikeVotes,
  returnYoutubeDislikeRequestUrl,
  type AbortLike,
  type ReturnYoutubeDislikeSettings,
  type ReturnYoutubeDislikeVotes,
  type Result,
} from '@visious/core';
import type { Platform } from '../platform/instance';
import { readJsonBody } from './json';
import type { ApiProblem } from './problem';

const NOTHING: ReturnYoutubeDislikeVotes = { dislikeCount: null };

/**
 * The Return YouTube Dislike lookup — the plain video id, always: unlike SponsorBlock/DeArrow's
 * title lookup this service has no k-anonymity form (`integrations.md`'s reason for this
 * integration being a different privacy story from the other two).
 *
 * Through the shared transport, so it retries and reports failures the way every other request
 * does.
 */
export async function fetchReturnYoutubeDislikeVotes(
  platform: Platform,
  settings: ReturnYoutubeDislikeSettings,
  videoId: string,
  signal?: AbortLike,
): Promise<Result<ReturnYoutubeDislikeVotes, ApiProblem>> {
  const url = returnYoutubeDislikeRequestUrl(settings, videoId);
  if (url === null) return ok(NOTHING);

  const response = await platform.transport.send({ method: 'GET', url, headers: {}, signal });
  if (!response.ok) return err({ kind: 'transport', error: response.error });

  const body = readJsonBody(response.value.body);
  if (!body.ok) return err(body.error);
  return ok(parseReturnYoutubeDislikeVotes(body.value));
}
